import { Reveal, Overline } from "@/components/motion";

const IMG = "https://images.pexels.com/photos/7156191/pexels-photo-7156191.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 sm:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <Reveal><Overline>The mission</Overline></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-display font-bold tracking-tight text-[#0B1E17] text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Britain runs on coffee. That habit can fund real change.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 text-base sm:text-lg text-[#52665E] leading-relaxed max-w-lg">
            Give &amp; Grind exists because shared spaces run on coffee — offices, gyms, student halls, leisure centres — and that daily ritual wasn't doing any good. We put specialty bean-to-cup machines into those spaces at zero cost to the host, and turn every flat white into a flat donation.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
            <div className="border-t-2 border-[#1B5E46] pt-4">
              <p className="font-display font-extrabold text-3xl text-[#0B1E17]">£0.22</p>
              <p className="text-xs text-[#52665E] mt-1">donated per cup, always</p>
            </div>
            <div className="border-t-2 border-[#D97706] pt-4">
              <p className="font-display font-extrabold text-3xl text-[#0B1E17]">Weekly</p>
              <p className="text-xs text-[#52665E] mt-1">published impact updates</p>
            </div>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.15}>
        <div className="relative">
          <div className="rounded-3xl overflow-hidden border border-[#E2DDD3] shadow-2xl shadow-[#1B5E46]/10">
            <img src={IMG} alt="Charity volunteers celebrating" className="w-full h-[440px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-[#0B1D16] text-[#FAF9F6] rounded-2xl px-6 py-5 shadow-xl">
            <p className="font-display font-extrabold text-2xl text-[#34D399]">£1,144</p>
            <p className="text-xs text-[#FAF9F6]/60">potential per machine, per year</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
